"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettify = void 0;
const types_1 = require("../../types");
const style_1 = require("../../style");
const code_1 = require("../../code");
function prettify(context) {
    const { dataPath, error: { params: { multipleOf } } } = types_1.getTypedContext(context);
    const [prePath, pathExpr, postPath] = style_1.pathDescription(context, 'value');
    const validStatement = style_1.style.title(`multiple of `, context) +
        style_1.style.number(`${multipleOf}`, context);
    const title = style_1.style.title(`The ${prePath}`, context) +
        pathExpr +
        style_1.style.title(`${postPath} should be a `, context) +
        validStatement + ' ' +
        style_1.style.title('(e.g. ', context) +
        [0, 1, 2, 3]
            .map(mul => style_1.style.number(`${mul * multipleOf}`, context))
            .concat([style_1.style.title('etc', context)])
            .join(style_1.style.operator(', ', context)) +
        style_1.style.title(')', context);
    const codeFrame = code_1.printCode('Ensure this is a ' + validStatement, context.parsedJson, { dataPath: dataPath.dotOnly, markIdentifier: false });
    return { title, codeFrame };
}
exports.prettify = prettify;
